export default __webpack_public_path__ + "static/media/icon_merchant_red.0adec52e.svg";